import React, { useState } from 'react';
import styles from './components/Css/ReadMore.module.css';
import { useAudiosByAudioType } from '../hooks/useAudiosHooks';
import { useNavigate } from 'react-router-dom';

const ReadMore = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const navigate = useNavigate();
  
  const { data: response, isLoading, error } = useAudiosByAudioType('Audio Book');
  
  // Early return for loading and error states
  if (isLoading) return <div className={styles.loading}>Loading...</div>;
  if (error) return <div className={styles.error}>Error loading content: {error}</div>;
  
  // Get audio data and pagination info from the response
  const audioItems = response?.data || [];
  const totalCount = response?.pagination?.total || 0;
  const totalPages = response?.pagination?.pages || 1;
  
  // Calculate current items based on pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = audioItems.slice(indexOfFirstItem, indexOfLastItem);
  
  // Handle page navigation
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.boxContainer}>
        <h1 className={styles.title}>Start with these</h1>
        
        <div className={styles.gridContainer}>
          {currentItems.map((item) => (
            <div key={item.id} className={styles.gridItem}>
              <div 
                className={styles.imageContainer}
                onClick={() => navigate(`/audio-play/${item.slug}`)}
              >
                <picture>
                  {/* Mobile image */}
                  <source
                    media="(max-width: 768px)"
                    srcSet={item.mobile_image_url}
                  />
                  {/* Desktop image */}
                  <img
                    src={item.computer_image_url}
                    alt={item.title || item.series_title}
                    className={styles.image}
                  />
                </picture>
              </div>
            </div>
          ))}
        </div>
        
        <div className={styles.pagination}>
          <button
            className={styles.pageButton}
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <div className={styles.pageIndicator}>
            Page {currentPage} of {totalPages}
          </div>
          <button
            className={`${styles.pageButton} ${styles.nextButton}`}
            onClick={nextPage}
            disabled={currentPage === totalPages}
          >
            Next Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReadMore;